export default function Logo({ compact = false }) {
  if (compact) {
    return (
      <img src="/logo-mark.png" alt="Built2Last.live" className="h-9 w-auto" data-testid="brand-logo" />
    );
  }
  return (
    <div className="flex items-center shrink-0" data-testid="brand-logo">
      <img src="/logo-dark.png" alt="Built2Last.live — Build Software. Live." className="h-7 sm:h-8 w-auto" />
    </div>
  );
}
